import { render, staticRenderFns } from "./customer-order-new.vue?vue&type=template&id=2ca3fe18&"
import script from "./customer-order-new.vue?vue&type=script&lang=ts&"
export * from "./customer-order-new.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports